import { cn } from '@/lib/cn';
import type { TicketListItem } from '@/domain/tickets';
import { MyBetTicketCard } from './MyBetTicketCard';

export interface KreditBetTicketCardProps {
  ticket: TicketListItem;
  currency?: string;
  onSelect?: (ticket: TicketListItem) => void;
  className?: string;
}

/**
 * Creditor picker row — same My Bets ticket chrome (legs, stake/odds/PW) with a Select CTA.
 */
export function KreditBetTicketCard({
  ticket,
  currency = '',
  onSelect,
  className,
}: KreditBetTicketCardProps) {
  return (
    <MyBetTicketCard
      ticket={ticket}
      currency={currency}
      onSelect={onSelect ? () => onSelect(ticket) : undefined}
      className={cn('shrink-0', className)}
    />
  );
}
